export default class TaskTimer {
  timeout = 15000;
  timer?: NodeJS.Timeout;
  callback?: () => void;

  constructor(timeout: number, callback?: () => void) {
    this.callback = callback;
    this.timeout = timeout;
  }

  start() {
    this.reset();
    this.timer = setTimeout(() => {
      this.runTask();
    }, this.timeout);
  }
  runTask() {
    this.callback?.();
  }

  reset() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = undefined;
    }
  }
}
